module.exports = __webpack_public_path__ + "static/paris-006.thumb-8eefecae6ec25dea70ed4539a28bc27a.jpg";